if (submitTag && userSignedUp && !localStorage.getItem(`sign_up${user}`)) {
    window.dataLayer.push({
      event: 'user_sign_up_complete',
      method: 'email'
    });
    localStorage.setItem(`sign_up${user}`, true);    
}